import { lazy, type ReactNode, Suspense } from 'react';
import { LiveTranscriptionProvider } from '../../../contexts/liveTranscription.context';

const DictationManager = lazy(() => import('../dictation/DictationManager'));

type Props = {
  children: ReactNode;
  dictationEnabled: boolean;
};

const LiveTranscriptionRoot = ({ children, dictationEnabled }: Props) => (
  <LiveTranscriptionProvider>
    {children}
    {dictationEnabled && (
      <Suspense fallback={null}>
        <DictationManager />
      </Suspense>
    )}
  </LiveTranscriptionProvider>
);

export default LiveTranscriptionRoot;
